import styled from '@emotion/styled'

export const Wrapper = styled.nav`
  padding: 0 3em;
  border-bottom: 2px solid ${props => props.theme.text};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  @media (max-width: ${props => props.theme.mobileBreakpoint}) {
    padding: 0 1em;
  }
`

export const Title = styled.div`
  font-size: .9em;
  font-weight: 800;
  letter-spacing: .1em;
  user-select: none;
  text-decoration: none;
  padding: .6em 0;
  display: flex;
  align-items: center;
  gap: 1em;
`

export const ProfileButton = styled.button`
  margin: 0;
  padding: .5em;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: .5em;
  font: inherit;
  color: inherit;

  img {
    height: 2em;
    width: 2em;
    display: block;
    border-radius: 10em;
    object-fit: cover;
  }
`

export const Menu = styled.div`
  position: absolute;
  top: 100%;
  right: 3em;
  background: ${props => props.theme.background};
  border: 2px solid currentColor;
  border-bottom-left-radius: .5em;
  border-bottom-right-radius: .5em;
  box-sizing: border-box;
  padding: .5em 0;
  z-index: 100;

  @media (max-width: ${props => props.theme.mobileBreakpoint}) {
    right: 1em;
  }

  a, button {
    text-decoration: none;
    margin: 0;
    padding: .5em 1em;
    background: none;
    border: none;
    cursor: pointer;
    font: inherit;
    color: inherit;
    font-size: .9em;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: .5em;
    box-sizing: border-box;

    &:hover {
      background: ${props => props.theme.menuHighlight};
    }
  }
`